export const version = 'v2.79.1';
